export default __webpack_public_path__ + "images/YD.4828d1c.png";